"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const better_react_mathjax_1 = require("better-react-mathjax");
const strikeCls = {
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    margin: '6px',
    minWidth: '30px',
};
const undoCls = {
    width: '30px',
    height: '30px',
    margin: '6px',
    marginLeft: '10px',
    minWidth: '30px',
};
function Choice({ index, description, selectedChoice, setSelectedChoice, showStrike = false }) {
    const [strike, setStrike] = (0, react_1.useState)(false);
    const chioceAlphabet = (index + 10).toString(36).toUpperCase();
    const handleSelected = () => {
        let selected = null;
        if (selectedChoice !== index) {
            selected = index;
        }
        if (setSelectedChoice) {
            setSelectedChoice(selected);
        }
    };
    const handleStrike = () => {
        setStrike(!strike);
        if (selectedChoice === index) {
            setSelectedChoice(null);
        }
    };
    (0, react_1.useEffect)(() => {
        setStrike(false);
    }, [description]);
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, sx: { display: 'inline-flex', marginTop: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    width: '100%',
                    border: 'gray 1px solid',
                    backgroundColor: selectedChoice === index ? 'primary.light' : 'default',
                    borderRadius: 1,
                }, className: (0, classnames_1.default)({ strikeout: strike }) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { position: 'relative', display: 'flex' }, onClick: handleSelected }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'inherit', variant: 'outlined', sx: {
                                borderRadius: '50%',
                                width: '30px',
                                height: '30px',
                                margin: '6px',
                                minWidth: '30px',
                            } }, { children: chioceAlphabet })), (0, jsx_runtime_1.jsx)(better_react_mathjax_1.MathJax, Object.assign({ style: { marginTop: '8px' }, inline: true, dynamic: true }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: description } }) }))] })) })), showStrike && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'inherit', variant: !strike ? 'outlined' : 'text', className: (0, classnames_1.default)({ strikeout: !strike }), onClick: handleStrike, sx: !strike ? strikeCls : undoCls }, { children: !strike ? chioceAlphabet : 'Undo' })))] })));
}
exports.default = Choice;
